<script>
export default {
  props: {
    module: Object,
  },
  methods: {
    changeHotel(id) {
      this.module.changeHotel(id);
    },
    changeRoom(id) {
      this.module.changeRoom(id);
    },
  },
};
</script>
<template>
  <Card
    v-if="module"
    class="p-t-c-ii  p-t-c-ii__hotel"
  >
    <CardBody style="padding-top: 16px;">
      <div class="p-t-c-ita__group" style="width: 50%;display: inline-block">
        <div class="p-t-c-ita__label" style="margin-bottom: 10px">
          <div class="p-t-c-ita__icon" style="width: 40px; display: inline-block">
            <div>
              <i class="el-icon-school"></i>
            </div>
          </div>
          <div class="p-t-c-ita__name" style="width: 50%;display: inline-block">
            Выбор отеля:
          </div>
        </div>
        <div class="p-t-c-ita__body">
          <div class="p-t-c-ita__select" style="width: 99%">
            <el-select v-model="module.hotel" clearable placeholder="Отель" @change="changeHotel" style="width: 100%">
              <el-option
                v-for="item in module.hotels"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="p-t-c-ita__group" v-if="module.rooms.length" style="width: 50%;display: inline-block">
        <div class="p-t-c-ita__label" style="margin-bottom: 10px">
          <div class="p-t-c-ita__icon" style="width: 40px; display: inline-block">
            <div>
              <i class="el-icon-school"></i>
            </div>
          </div>
          <div class="p-t-c-ita__name" style="width: 50%;display: inline-block">
            Выбор номера:
          </div>
        </div>
        <div class="p-t-c-ita__body">
          <div class="p-t-c-ita__select"  style="width: 99%">
            <el-select v-model="module.room" clearable placeholder="Номер" @change="changeRoom" style="width: 100%">
              <el-option
                v-for="item in module.rooms"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </CardBody>
  </Card>
</template>
<style lang="scss" scoped>
  .p-t-c-ii {
  &__hotel {

    .p-t-c-ita__icon {
      div {
        height: 34px;
        width: 34px;
        border-radius: 50%;
        background: #FAB24C;

        i {
          margin: 25%;
        }
      }
    }

    .p-t-c-ita__select {
      .el-input {
        .el-input__inner {
          border: none;
          border-radius: 0px;
          border-bottom: 1px solid #07080F;
        }
      }
    }
  }
    &__group {
      margin-bottom: 8px;
      font-size: 16px;

      span {
        display: inline-block;
        width: 150px;
        font-weight: 700;
      }
    }

    &__preview {
      width: 180px;
      height: 180px;
      margin-right: 16px;
      flex-shrink: 0;
      line-height: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  @media (max-width: 600px) {
    .p-t-c-ii {
      .card-body--flex {
        display: block;
      }
    }
    .p-t-c-ii__preview {
      width: 100%;
      margin: 0 0 16px 0;
    }
  }
</style>
